// extracted by mini-css-extract-plugin
export default {"wrapper":"sV-z","availablePromoMessagesLabel":"tV-z","promoMessageList":"uV-z","promoMessage":"vV-z","appliedPromoMessage":"wV-z","promoMessageAmount":"xV-z"};